/**
 * MicStatus object containing configurations for different microphone states
 */
export const MicStatus = {
  ready: {
    status: 'ready',
    description: 'Ready to record',
    icon: 'pi pi-microphone',
    buttonLabel: 'Record',
    severity: 'secondary',
  },
  recording: {
    status: 'recording',
    description: 'Recording audio',
    icon: 'pi pi-circle-on',
    buttonLabel: 'Recording...',
    severity: 'danger',
  },
  listening: {
    status: 'listening',
    description: 'Listening for speech',
    icon: 'pi pi-wave-pulse',
    buttonLabel: 'Listening...',
    severity: 'info',
  },

  initializing: {
    status: 'initializing',
    description: 'Listening',
    icon: 'pi pi-microchip-ai',
    buttonLabel: 'initializing...',
    severity: 'info',
  },
  inactive: {
    status: 'inactive',
    description: 'Inactive',
    icon: 'pi pi-microphone',
    buttonLabel: 'Record',
    severity: 'primary',
  },
  error: {
    status: 'error',
    description: 'Error occurred',
    icon: 'pi pi-exclamation-triangle',
    buttonLabel: 'Try again',
    severity: 'warning',
  },
  paused: {
    status: 'paused',
    description: 'Paused - waiting for signal',
    icon: 'pi pi-hourglass',
    buttonLabel: 'Paused',
    severity: 'help',
  },
} as const;

export type MicStatusLiteral = keyof typeof MicStatus;

export interface AudioRecording {
  id: string;
  timestamp: Date;
  url: string;
  duration: number;
  blob: Blob;
}

/**
 * MicStatus configuration interface
 */
export interface MicStatusConfig {
  status: string;
  description: string;
  icon: string;
  buttonLabel: string;
  severity: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help';
}
